import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ibiyryyjfavrynklihsh.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImliaXlyeXlqZmF2cnlua2xpaHNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg0OTYwMjcsImV4cCI6MjA4NDA3MjAyN30.wGx9Poq5yyNsqtJq5rRP2Ur3ITzJAHVqrdZqh1rXHHU';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Profile {
  id: string;
  email: string;
  name: string;
  role: 'Nurse' | 'Physician' | 'Pharmacist' | 'Admin' | 'Student';
  organization?: string;
  country?: string;
  is_verified: boolean;
  subscription: 'free' | 'professional' | 'enterprise';
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
  subscription_status: string;
  subscription_end_date?: string;
  created_at: string;
  updated_at: string;
}

export interface ClinicalFeedback {
  id: string;
  user_id?: string;
  content_type: 'condition' | 'drug' | 'protocol';
  content_id: string;
  content_name: string;
  feedback_type: 'error' | 'suggestion' | 'clarification' | 'outdated';
  description: string;
  severity?: 'low' | 'medium' | 'high' | 'critical';
  status: 'pending' | 'reviewed' | 'implemented' | 'rejected';
  reviewer_notes?: string;
  reviewed_by?: string;
  reviewed_at?: string;
  created_at: string;
}

export interface Consultation {
  id: string;
  requester_id?: string;
  condition_id: string;
  condition_name: string;
  patient_context?: string;
  question: string;
  urgency: 'routine' | 'urgent' | 'emergency';
  status: 'pending' | 'assigned' | 'answered' | 'closed';
  assigned_physician_id?: string;
  response?: string;
  responded_at?: string;
  created_at: string;
}

export interface Bookmark {
  id: string;
  user_id: string;
  content_type: 'condition' | 'drug';
  content_id: string;
  content_name: string;
  notes?: string;
  created_at: string;
}
